import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	from: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.from',
		defaultMessage: 'From',
		description: 'Input label to select from date.',
	},
	to: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.to',
		defaultMessage: 'To',
		description: 'Input label to select to date.',
	},
	update: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.update',
		defaultMessage: 'Update',
		description: 'Update button text',
	},
});
